import React, { useState, useEffect } from "react";
import { Form, Card, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as authActions from "../../../redux/actions/authAction";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ResetPassword = () => {
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [cpassword, setCPassword] = useState("");
  const [accessCode, setAccessCode] = useState("");

  const [passwordError, setPasswordError] = useState("");
  const [cpasswordError, setCpasswordError] = useState("");
  const [accessCodeError, setAccessCodeError] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmitForm = (e) => {
    e.preventDefault();
    setPasswordError("");
    setCpasswordError("");
    setAccessCodeError("");

    let valid = true;

    if (password !== cpassword) {
      setCpasswordError("Passwords do not match");
      valid = false;
    }
    if (!accessCode) {
      setAccessCodeError("Verification code is required");
      valid = false;
    } else if (accessCode.length !== 6) {
      setAccessCodeError("Verification code must be 6 digits");
      valid = false;
    }

    if (!valid) return;

    const email = localStorage.getItem("user");

    console.log("TOKEN: ", email)

    const obj = { password, accessCode, email };

    setIsLoading(true);
    dispatch(authActions.userResetPasswordRequest(obj, callback));
  };

  const callback = (status, message) => {
    setIsLoading(false);
    console.log("Status: ", status)
    console.log("Message: ", message)

    if (status === 200) {
      localStorage.removeItem("user");
      toast.success("Password has been reset. Please log in again.");
      window.location.href = "/login";
    } else {
      toast.error(message || "Error resetting password");
    }
  };

  return (
    <>
      <div className="reset-password">
        <div className="text-center my-3">
          <img src="/img/logo@2x.png" className="img-fluid" />
        </div>
        <div className="background-screen">
          <div className="d-grid justify-content-center align-items-center h-100">
            <Card>
              <Card.Body className="mx-5 my-5">
                <h3 className="text-center mb-4 font-weight-bold">
                  Reset Password
                </h3>
                <p className="text-center">
                  Please enter the verification code and your new password
                </p>
                <Form onSubmit={handleSubmitForm}>
                  <Form.Group className="mb-4">
                    <Form.Label>Verification Code</Form.Label>
                    <Form.Control
                      type="text"
                      maxLength={6}
                      value={accessCode}
                      onChange={(e) => setAccessCode(e.target.value)}
                      isInvalid={!!accessCodeError}
                    />
                    <Form.Control.Feedback type="invalid">
                      {accessCodeError}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>New Password</Form.Label>
                    <Form.Control
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      isInvalid={!!passwordError}
                    />
                    <Form.Control.Feedback type="invalid">
                      {passwordError}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Confirm Password</Form.Label>
                    <Form.Control
                      type="password"
                      value={cpassword}
                      onChange={(e) => setCPassword(e.target.value)}
                      isInvalid={!!cpasswordError}
                    />
                    <Form.Control.Feedback type="invalid">
                      {cpasswordError}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <div className="text-center">
                    {isLoading ? (
                      <button className="btn-login btn-lg" disabled>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      </button>
                    ) : (
                      <button type="submit" className="btn-login btn-lg">
                        Reset Password
                      </button>
                    )}
                  </div>
                </Form>
              </Card.Body>
            </Card>
            <p className="text-center text-white mt-3">
              &copy; 2022 EQWELL ~ All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default ResetPassword;
